export class File {

    id;
    path;
    isPreview = 0;
    isImage = false;

    static createFromObj(obj) {
        const file = new File(obj.id, obj.path);
        file.isPreview = obj.isPreview;
        file.isImage = obj.isImage;
        return file;
    }

    constructor(id, path) {
        this.id = id;
        this.path = path;
    }

}